import { BASE_URL } from '../constants/Constants';
import axiosInstance from './axiosInstance';

export const getSymbolSpecificationByViewId = async (viewId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/symbol-specification/view/${viewId}`);    
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error('Error fetching symbol specification:', error);
    return error.response.data;    
    //throw error;
  }
};